// extracted by mini-css-extract-plugin
module.exports = {"component":"TheDiscardedCardPopup_component__DR0Zc"};